<ng-container
  [appTransition]="child"
  [show]="loading()"
  [duration]="300"
  enter="transition-all"
  enterFrom="opacity-0"
  enterTo="opacity-100"
  leave="transition-all"
  leaveFrom="opacity-100"
  leaveTo="opacity-0"
>
  <div #child class="loading">
    <span class="pi pi-spinner"></span>
  </div>
</ng-container>
